export type AthenaQueryErrorCode =
	| "ATHENA_QUERY_INVALID_SOURCE"
	| "ATHENA_QUERY_UNKNOWN_FIELD"
	| "ATHENA_QUERY_UNKNOWN_RELATION"
	| "ATHENA_QUERY_AMBIGUOUS_RELATION"
	| "ATHENA_QUERY_INVALID_PAGINATION"
	| "ATHENA_QUERY_UNSUPPORTED_OPERATOR"
	| "ATHENA_QUERY_INVALID_NESTING"
	| "ATHENA_QUERY_INVALID_IDENTIFIER"
	| "ATHENA_QUERY_INVALID_SELECTION"
	| "ATHENA_QUERY_INVALID_CONDITION"
	| "ATHENA_QUERY_INVALID_NORMALIZED_AST"
	| "ATHENA_QUERY_COMPLEXITY_EXCEEDED"
	| "ATHENA_QUERY_MAX_DEPTH_EXCEEDED"
	| "ATHENA_QUERY_CYCLIC_INPUT"
	| "ATHENA_QUERY_RELATION_METADATA_CONFLICT"
	| "ATHENA_QUERY_UNSUPPORTED_CAPABILITY";

export class AthenaQueryError extends Error {
	readonly code: AthenaQueryErrorCode;

	constructor(code: AthenaQueryErrorCode, message: string) {
		super(message);
		this.name = "AthenaQueryError";
		this.code = code;
	}
}
